// src/pwa/components/FooterPwa.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/footerPwa.css?v=2025-09-24-05"'; 

const BASE = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const icon = (f) => `${BASE}/pwa/icons/${f}`; // public/pwa/icons/ 配下

export default function FooterPwa() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = (p) => pathname.startsWith(p);

  const leftActive  = isActive('/all');
  const rightActive = isActive('/my');

  return (
    <nav
      className={[
        'footer-nav',
         'edgefill', 
        leftActive  ? 'tab-left-active'  : 'tab-left-inactive',
        rightActive ? 'tab-right-active' : 'tab-right-inactive',
      ].join(' ')}
      role="navigation"
      aria-label="フッターメニュー"
    >
      {/* 背景レイヤー（左右1/2を塗る） */}
      <div className="footer-bg" aria-hidden>
        <span className="footer-bg-left" />
        <span className="footer-bg-right" />
      </div>

      {/* 左タブ */}
      <button
        type="button"
        className={`footer-button footer-button--left ${leftActive ? 'is-active' : ''}`}
        onClick={() => navigate('/all')}
        aria-current={leftActive ? 'page' : undefined}
      >
        <img src={icon('menu-all-192.png')} alt="" className="footer-icon" width={26} height={26} />
        <span>受付番号一覧</span>
      </button>

      {/* 中央（縦並び） */}
      <button
        type="button"
        className={`footer-center-button ${isActive('/book') ? 'is-active' : ''}`}
        onClick={() => navigate('/book')}
        aria-current={isActive('/book') ? 'page' : undefined}
      >
        <img src={icon('menu-book-192.png')} alt="" className="footer-icon--center" width={34} height={34} />
        <span className="footer-center-label">受付番号予約</span>
      </button>

      {/* 右タブ */}
      <button
        type="button"
        className={`footer-button footer-button--right ${rightActive ? 'is-active' : ''}`}
        onClick={() => navigate('/my')}
        aria-current={rightActive ? 'page' : undefined}
      >
        <img src={icon('menu-my-192.png')} alt="" className="footer-icon" width={26} height={26} />
        <span>予約状況</span>
      </button>
    </nav>
  );
}